import { CLEAR_SHIFT } from "./types";

export default () => {
    return { type: CLEAR_SHIFT };
};
